"use client";

import { m as motion } from "framer-motion";
import { Users, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { fadeInUp, defaultViewport, defaultTransition } from "@/lib/motion";

export const TeamBridgeSection = () => {
  return (
    <motion.section
      initial={fadeInUp.initial}
      whileInView={fadeInUp.animate}
      viewport={defaultViewport}
      transition={defaultTransition}
      className="container-class"
    >
      <div className="section-inner">
        <div className="glass-card p-8 md:p-12 rounded-3xl text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-secondary/10 mb-6">
            <Users className="w-8 h-8 text-secondary" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="gradient-text">Want this for your whole team?</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8">
            Run a private cohort for your HR organization. Same expert-led curriculum, 
            customized to your company's AI adoption goals and challenges.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/team-training"
              className="group inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-secondary text-secondary-foreground font-semibold hover:opacity-90 transition-all duration-300"
            >
              Learn More
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href="https://cal.com/jonathanflower/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl glass hover:glass-strong font-semibold transition-all duration-300"
            >
              Schedule a Call
            </a>
          </div>
        </div>
      </div>
    </motion.section>
  );
};
